<template>
  <div class="pg-wrap">

    <!-- Loading state -->
    <div v-if="loading" class="pg-loading">
      <div class="pg-spinner"></div>
      <span>Carregando perfil…</span>
    </div>

    <template v-else>

      <!-- ─── Photo Section ─── -->
      <div class="pg-section pg-photo-section">
        <div class="pg-avatar-area">
          <div class="pg-avatar-circle">
            <img v-if="perfil.user_photo_url" :src="perfil.user_photo_url" class="pg-avatar-img" alt="avatar">
            <span v-else class="pg-avatar-initials">{{ initials }}</span>
          </div>
          <div class="pg-avatar-actions">
            <input ref="fileInput" type="file" accept="image/*" class="d-none" @change="onFileSelected">
            <button class="pg-btn pg-btn-outline" @click="$refs.fileInput.click()">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><polyline points="17 8 12 3 7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
              Alterar foto
            </button>
            <button v-if="perfil.user_photo_url" class="pg-btn pg-btn-ghost-red" @click="removePhoto">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M19 6l-1 14H6L5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M10 11v6M14 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
              Remover
            </button>
          </div>
          <div class="pg-avatar-hint">JPG, PNG ou GIF. Máximo 2 MB.</div>
          <div v-if="uploadingPhoto" class="pg-upload-progress">
            <div class="pg-upload-bar" :style="{ width: uploadProgress + '%' }"></div>
            <span>{{ uploadProgress }}%</span>
          </div>
        </div>
      </div>

      <!-- ─── Divider ─── -->
      <div class="pg-divider-label">Informações pessoais</div>

      <!-- ─── Personal Info ─── -->
      <div class="pg-section">
        <div class="pg-form-grid">

          <div class="pg-field">
            <label class="pg-label">Nome</label>
            <input v-model="perfil.user_name" class="pg-input" placeholder="Seu nome" type="text">
          </div>

          <div class="pg-field">
            <label class="pg-label">Sobrenome</label>
            <input v-model="perfil.user_sobrenome" class="pg-input" placeholder="Seu sobrenome" type="text">
          </div>

          <div class="pg-field">
            <label class="pg-label">Nome de apresentação</label>
            <input v-model="perfil.user_display_name" class="pg-input" placeholder="Como prefere ser chamado?" type="text">
            <span class="pg-field-hint">Este nome aparece no dashboard e relatórios</span>
          </div>

          <div class="pg-field">
            <label class="pg-label">Telefone / WhatsApp</label>
            <input v-model="perfil.user_phone" class="pg-input" placeholder="(11) 99999-9999" type="tel">
          </div>

          <div class="pg-field pg-field-full">
            <label class="pg-label">E-mail</label>
            <input :value="perfil.user_email" class="pg-input pg-input-disabled" disabled type="email">
            <span class="pg-field-hint">O e-mail não pode ser alterado diretamente. Entre em contato com o suporte.</span>
          </div>

        </div>
      </div>

      <!-- ─── Divider ─── -->
      <div class="pg-divider-label">Conta e preferências</div>

      <!-- ─── Account Prefs ─── -->
      <div class="pg-section">
        <div class="pg-form-grid">

          <div class="pg-field">
            <label class="pg-label">Idioma preferido</label>
            <select v-model="perfil.user_idioma" class="pg-input pg-select">
              <option value="pt-BR">Português (Brasil)</option>
              <option value="en">English</option>
              <option value="es">Español</option>
            </select>
          </div>

          <div class="pg-field">
            <label class="pg-label">Fuso horário</label>
            <select v-model="perfil.user_timezone" class="pg-input pg-select">
              <option value="America/Sao_Paulo">Brasília (GMT-3)</option>
              <option value="America/Manaus">Manaus (GMT-4)</option>
              <option value="America/Belem">Belém (GMT-3)</option>
              <option value="America/New_York">Nova York (GMT-5)</option>
              <option value="Europe/Lisbon">Lisboa (GMT+0)</option>
            </select>
          </div>

          <div class="pg-field pg-field-full">
            <label class="pg-label">Bio / Apresentação</label>
            <textarea v-model="perfil.user_bio" class="pg-input pg-textarea" placeholder="Conte um pouco sobre você ou sua empresa…" rows="3"></textarea>
          </div>

          <div class="pg-field pg-field-full">
            <label class="pg-label">URL do seu site / domínio</label>
            <input v-model="perfil.user_onboarding_site_url" class="pg-input" placeholder="www.meusite.com.br" type="text">
            <span class="pg-field-hint">Usado para mostrar o fundo real da página no Heatmap.</span>
          </div>

        </div>
      </div>

      <!-- ─── Footer ─── -->
      <div class="pg-footer">
        <button class="pg-btn pg-btn-ghost" @click="listar">Descartar alterações</button>
        <button class="pg-btn pg-btn-primary" :disabled="saving" @click="updateSubmit">
          <span v-if="saving" class="pg-btn-spinner"></span>
          {{ saving ? 'Salvando…' : 'Salvar alterações' }}
        </button>
      </div>

    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { UsuarioService } from '@/services/loginService'

export default {
  data() {
    return {
      loading: true,
      saving: false,
      uploadingPhoto: false,
      uploadProgress: 0,
      userData: JSON.parse(localStorage.getItem('userData')) || {},
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3 || '/api/dkbucket',
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      perfil: {
        user_name: '',
        user_sobrenome: '',
        user_email: '',
        user_phone: '',
        user_photo_url: '',
        user_display_name: '',
        user_bio: '',
        user_idioma: 'pt-BR',
        user_timezone: 'America/Sao_Paulo',
        user_file_key: '',
        user_perfil_file_key: '',
        user_onboarding_site_url: '',
      },
    }
  },

  computed: {
    initials() {
      const n = (this.perfil.user_name || '')[0] || ''
      const s = (this.perfil.user_sobrenome || '')[0] || ''
      return (n + s).toUpperCase() || '?'
    },
  },

  async created() {
    await this.listar()
  },

  methods: {
    async listar() {
      this.loading = true
      try {
        const response = await UsuarioService.getUsuario(this.userData.id)
        const data = Array.isArray(response.data) ? response.data[0] : response.data
        if (data) {
          this.perfil = {
            user_name: data.user_name || '',
            user_sobrenome: data.user_sobrenome || '',
            user_email: data.user_email || '',
            user_phone: data.user_phone || '',
            user_photo_url: data.user_photo_url || '',
            user_display_name: data.user_display_name || '',
            user_bio: data.user_bio || '',
            user_idioma: data.user_idioma || 'pt-BR',
            user_timezone: data.user_timezone || 'America/Sao_Paulo',
            user_file_key: data.user_file_key || '',
            user_perfil_file_key: data.user_perfil_file_key || '',
            user_onboarding_site_url: data.user_onboarding_site_url || '',
          }
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async onFileSelected(e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > 2 * 1024 * 1024) {
        this.$notify({ title: 'Arquivo muito grande', message: 'A foto deve ter no máximo 2 MB.', type: 'warning' })
        return
      }

      this.uploadingPhoto = true
      this.uploadProgress = 0

      const formData = new FormData()
      formData.append('file', file)
      formData.append('caminho', `${this.perfil.user_file_key}perfil-de-usuario/`)

      try {
        const resp = await axios.post(
          `${this.VUE_APP_HOST_API_AWS_S3}/uploadImageAvatar?caminho=${this.perfil.user_file_key}perfil-de-usuario/`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => {
              this.uploadProgress = Math.round((e.loaded / e.total) * 100)
            },
          },
        )

        const data = resp.data && resp.data.data ? resp.data.data : null
        if (data) {
          this.perfil.user_photo_url = data.fileUrl || this.perfil.user_photo_url
          this.perfil.user_perfil_file_key = data.key_filename || this.perfil.user_perfil_file_key
          await this.savePhotoUrl()
          const user = JSON.parse(localStorage.getItem('userData'))
          user.user_photo_url = this.perfil.user_photo_url
          localStorage.setItem('userData', JSON.stringify(user))
          this.$emit('avatarUpdated', this.perfil.user_photo_url)
          this.$notify({ title: 'Foto atualizada!', message: 'Foto de perfil alterada com sucesso.', type: 'success' })
        }
      } catch (err) {
        console.error(err)
        this.$notify({ title: 'Erro', message: 'Não foi possível enviar a foto.', type: 'error' })
      } finally {
        this.uploadingPhoto = false
      }
    },

    async savePhotoUrl() {
      await fetch(`${this.VUE_APP_HOST_API_BACKEND}/url/${this.userData.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_photo_url: this.perfil.user_photo_url,
          user_perfil_file_key: this.perfil.user_perfil_file_key,
        }),
      })
    },

    removePhoto() {
      this.perfil.user_photo_url = ''
    },

    async updateSubmit() {
      this.saving = true
      try {
        await fetch(`${this.VUE_APP_HOST_API_BACKEND}/usuario/${this.userData.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_name: this.perfil.user_name,
            user_email: this.perfil.user_email,
            user_phone: this.perfil.user_phone,
            user_sobrenome: this.perfil.user_sobrenome,
            user_onboarding_site_url: this.perfil.user_onboarding_site_url || null,
          }),
        })

        const user = JSON.parse(localStorage.getItem('userData'))
        user.user_name = this.perfil.user_name
        user.user_phone = this.perfil.user_phone
        user.user_sobrenome = this.perfil.user_sobrenome
        localStorage.setItem('userData', JSON.stringify(user))

        this.$notify({ title: 'Perfil atualizado!', message: 'Suas informações foram salvas com sucesso.', type: 'success' })
        await this.listar()
      } catch (err) {
        console.error(err)
        this.$notify({ title: 'Erro', message: 'Não foi possível salvar as informações.', type: 'error' })
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.d-none { display: none !important; }

/* ─── Wrapper ─── */
.pg-wrap { background: var(--dk-bg-card, #fff); border-radius: 0 0 16px 16px; color: var(--dk-text-primary, #1a2d42); }

/* ─── Loading ─── */
.pg-loading {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 12px; padding: 60px 24px; color: var(--dk-text-muted, #8a94a6); font-size: 14px;
}
.pg-spinner {
  width: 36px; height: 36px; border-radius: 50%;
  border: 3px solid var(--dk-border-light, #f0f2f5); border-top-color: #E86A10;
  animation: pg-spin 0.9s linear infinite;
}
@keyframes pg-spin { to { transform: rotate(360deg); } }

/* ─── Sections ─── */
.pg-section { padding: 20px 24px; }

.pg-divider-label {
  padding: 10px 24px;
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--dk-text-faint, #aab0bc);
  background: var(--dk-bg-inset, #fafbfc);
  border-top: 1px solid var(--dk-border-light, #f5f6fa);
  border-bottom: 1px solid var(--dk-border-light, #f5f6fa);
}

/* ─── Avatar ─── */
.pg-photo-section { display: flex; }
.pg-avatar-area { display: flex; align-items: center; gap: 20px; flex-wrap: wrap; }
.pg-avatar-circle {
  width: 88px; height: 88px; border-radius: 50%;
  background: linear-gradient(135deg, #0D3349, #1a4d6b);
  display: flex; align-items: center; justify-content: center;
  overflow: hidden; flex-shrink: 0;
  border: 3px solid rgba(232,106,16,0.4);
}
.pg-avatar-img { width: 100%; height: 100%; object-fit: cover; }
.pg-avatar-initials { font-size: 28px; font-weight: 700; color: #E86A10; }
.pg-avatar-actions { display: flex; gap: 8px; flex-wrap: wrap; }
.pg-avatar-hint { font-size: 11.5px; color: var(--dk-text-faint, #aab0bc); width: 100%; }
.pg-upload-progress { width: 100%; }
.pg-upload-bar { height: 4px; background: linear-gradient(90deg, #E86A10, #F5B935); border-radius: 4px; transition: width 0.3s; }

/* ─── Form Grid ─── */
.pg-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.pg-field { display: flex; flex-direction: column; gap: 6px; }
.pg-field-full { grid-column: 1 / -1; }
.pg-label { font-size: 12.5px; font-weight: 600; color: var(--dk-text-secondary, #344563); }
.pg-field-hint { font-size: 11.5px; color: var(--dk-text-faint, #aab0bc); }

.pg-input {
  padding: 10px 13px; border-radius: 9px;
  border: 1.5px solid var(--dk-border-input, #e5e8ef); background: var(--dk-bg-input, #fff);
  font-size: 14px; color: var(--dk-text-primary, #1a2d42); outline: none;
  transition: border-color 0.15s;
}
.pg-input:focus { border-color: #E86A10; box-shadow: 0 0 0 3px rgba(232,106,16,0.1); }
.pg-input-disabled { background: var(--dk-bg-inset, #f9fafb); color: var(--dk-text-muted, #9ca3af); cursor: not-allowed; }
.pg-select { appearance: none; cursor: pointer; }
.pg-textarea { resize: vertical; min-height: 80px; font-family: inherit; }

/* ─── Footer ─── */
.pg-footer {
  display: flex; justify-content: flex-end; gap: 10px;
  padding: 16px 24px;
  border-top: 1.5px solid var(--dk-border-light, #f5f6fa);
}

/* ─── Buttons ─── */
.pg-btn {
  display: inline-flex; align-items: center; gap: 7px;
  padding: 9px 18px; border-radius: 9px;
  font-size: 13.5px; font-weight: 600; cursor: pointer; border: none;
  transition: all 0.15s;
}
.pg-btn-primary { background: linear-gradient(135deg, #E86A10, #f08535); color: #fff; box-shadow: 0 4px 12px rgba(232,106,16,0.25); }
.pg-btn-primary:hover:not(:disabled) { background: linear-gradient(135deg, #cf5e0d, #E86A10); }
.pg-btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
.pg-btn-outline { background: var(--dk-bg-input, #fff); color: #E86A10; border: 1.5px solid #E86A10; }
.pg-btn-outline:hover { background: rgba(232,106,16,0.05); }
.pg-btn-ghost { background: var(--dk-bg-inset, #f5f6fa); color: var(--dk-text-secondary, #6b7280); }
.pg-btn-ghost:hover { background: var(--dk-bg-segment, #edf0f3); }
.pg-btn-ghost-red { background: none; color: #C12B2B; border: 1.5px solid rgba(193,43,43,0.3); }
.pg-btn-ghost-red:hover { background: rgba(193,43,43,0.06); }

.pg-btn-spinner {
  width: 14px; height: 14px; border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.4); border-top-color: var(--dk-bg-card, #fff);
  animation: pg-spin 0.7s linear infinite; display: inline-block;
}

@media (max-width: 600px) {
  .pg-form-grid { grid-template-columns: 1fr; }
  .pg-avatar-area { flex-direction: column; align-items: flex-start; }
}
</style>
